import { render, staticRenderFns } from "./mainBodyInstructions.vue?vue&type=template&id=44aa1678&scoped=true&"
import script from "./mainBodyInstructions.vue?vue&type=script&lang=js&"
export * from "./mainBodyInstructions.vue?vue&type=script&lang=js&"
import style0 from "./mainBodyInstructions.vue?vue&type=style&index=0&id=44aa1678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aa1678",
  null
  
)

export default component.exports